export default __webpack_public_path__ + "static/media/747.2d33b4f9.png";